module.exports = __webpack_public_path__ + "img/CommentAddedIcon.f9077b85.svg";